import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { space, fontSize, fontWeight } from 'styled-system';
import theme from 'styled-theming';

const linkColor = theme('mode', {
  light: (props) => props.theme.colors.lightGreyBlue,
  dark: (props) => props.theme.colors.brightRichBlue,
});

const linkHoverColor = theme('mode', {
  light: (props) => props.theme.colors.brightRichBlue,
  dark: (props) => props.theme.colors.aqua,
});

const NavigationLink = styled(NavLink)`
  transition: ${(props) => props.theme.animation.normal};
  ${space}
  ${fontSize}
  ${fontWeight}
  border-radius: ${(props) => props.theme.radius.small};
  color: ${linkColor};
  text-decoration: none;
  &:hover {
    color: ${linkHoverColor};
  }
`;

export default NavigationLink;
